import Api from "../services/Api";
import { observable, action } from "mobx";

class UserStore {
  @observable isPremium: boolean = false;
  @observable needToUpgrade: boolean = false;

  api: Api;

  constructor(api: Api) {
    this.api = api;
    this.setIsUserPremium();
    this.checkNeedToUpgrade();
  }

  @action setIsUserPremium = async () => {
    const response = await this.api.isUserPremium();

    try {
      this.isPremium = response.data.is_premium;
    } catch (e) {}
  };

  @action checkNeedToUpgrade = async () => {
    const response = await this.api.checkNeedToUpgrade();
    try {
      this.needToUpgrade = response.data.need_to_upgrade;
      console.log('this.needToUpgrade',this.needToUpgrade);
    } catch (e) {}
  };
}

export default UserStore;
